import { StyleSheet } from 'aphrodite';
import { THEME } from '../../../../web/components-v2/Theme/theme';

// A reading width, not a layout breakpoint: wide panes leave long lines of email text hard to follow.
const CONVERSATION_COLUMN_MAX_WIDTH = 1120;
// The thread area's side padding. The composer host repeats it so the open composer card lines up with the
// emails at every pane width, not only once the pane is wide enough to center both columns.
const CONVERSATION_SIDE_PADDING = THEME.space[16];

const conversationColumn = {
	width: '100%',
	maxWidth: CONVERSATION_COLUMN_MAX_WIDTH,
	marginLeft: 'auto',
	marginRight: 'auto',
} as const;

export const conversationPaneStyles = StyleSheet.create({
	// Muted inline notice for a degraded timeline (e.g. the activity-events endpoint is down).
	// Deliberately quiet — the conversation itself still renders and stays usable.
	timelineNotice: {
		color: THEME.colors.text.light,
		fontSize: 12,
		padding: `${THEME.spacing.xs}px ${THEME.spacing.sm}px`,
		textAlign: 'center',
	},
	threadArea: {
		flex: 1,
		minHeight: 0,
		overflowY: 'auto',
		padding: `${THEME.space[8]}px ${CONVERSATION_SIDE_PADDING}px`,
	},
	threadColumn: {
		...conversationColumn,
		display: 'flex',
		flexDirection: 'column',
		// No flex gap: each ThreadItem/EventItem already supplies its own marginTop
		// (styles.thread). A gap here would stack on top of that margin and double the
		// space between messages — let the bubble margin be the single source of spacing.
		gap: 0,
	},
	// Keep the final thread above the absolutely positioned collapsed composer.
	threadAreaFloatingComposer: {
		paddingBottom: 60,
	},
	// Scrolls once the composer outgrows the pane, whose hidden overflow would eat the send bar.
	composerHost: {
		...conversationColumn,
		minHeight: 0,
		overflowY: 'auto',
		// Phones get no padding: there the open card is fixed to the full viewport, and the host holds nothing
		// in flow that padding could align.
		[`@media (min-width: ${THEME.breakpoints.md}px)`]: {
			boxSizing: 'border-box',
			maxWidth: CONVERSATION_COLUMN_MAX_WIDTH + 2 * CONVERSATION_SIDE_PADDING,
			paddingLeft: CONVERSATION_SIDE_PADDING,
			paddingRight: CONVERSATION_SIDE_PADDING,
		},
	},
});
